import React from 'react'
import styled from 'styled-components'

import ShowMoreText from '../../../components/ShowMoreText'
import { Section, SubSection, SectionTitle } from './shared'

const NotesSection = styled(Section)`
  ${SubSection} {
    &:last-child {
      margin-bottom: 0;
    }
  }
`

export default ({ listing }) => (
  <NotesSection>
    {listing.whats_provided && (
      <SubSection>
        <SectionTitle>What’s Provided</SectionTitle>
        <ShowMoreText lines={5}>{listing.whats_provided}</ShowMoreText>
      </SubSection>
    )}

    {listing.things_to_note && (
      <SubSection>
        <SectionTitle>Things to Note</SectionTitle>
        <ShowMoreText lines={5}>{listing.things_to_note}</ShowMoreText>
      </SubSection>
    )}
  </NotesSection>
)
